import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  if (localStorage.getItem('AccessToken') != null) {
    return true;
  } else {
    // router.navigate(['/landing-page']);
    localStorage.clear();
    router.navigate(['/login']);
    return false;
  }
};
